var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.id,attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"group":"plk","position":"bottom right"}}),_c('v-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }